import { Theme } from "@material-ui/core";
import clsx from "clsx";
import React from "react";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import { ICardElementWithChildren } from "backend/model/model";
import BlueChip from "../texts/BlueChip";
import ElementIcon from "../icons/ElementIcon";

const useStyles = makeThemedStyles("ConfigReportCard", (theme: Theme) => ({
  root: {
    cursor: "pointer",
    fontSize: "10px",
    background: "rgba(255, 255, 255)",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    width: "260px",
    height: "14.1em",
    borderRadius: "1.8em",
    overflow: "hidden",
    paddingBottom: "0.9em",
    display: "flex",
    flexDirection: "column",
  },
  upperContent: {
    background: "rgba(250, 250, 252, 1)",
    height: "9.4em",
    width: "100%",
    padding: "1.6em",
    display: "block",
    alignItems: "start",
    justifyContent: "space-between",
    "&.active": {
      background: "rgba(237, 242, 248, 1) !important",
    },
  },
  title: {
    fontSize: "14px",
    lineHeight: "1.25em",
    fontWeight: 500,
    letterSpacing: "0.05625px",
    marginBottom: "2px",
    color: "rgba(63, 69, 79, 1)",
    maxWidth: "10.93em",
  },
  selectBox: {
    marginTop: "-0.7em",
    marginRight: "-0.7em",
  },
  bottomContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 500,
    fontSize: "1.2em",
    lineHeight: 1,
    color: "#4C5157",
    height: "2em",
    background: "rgba(225, 245, 255, 1)",
    borderRadius: "1.25em",
    padding: ".375em 1.33em",
    width: "min-content",
    margin: "auto auto 0",
  },
  typestyle: {
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "1.71em",
    textTransform: "uppercase",
    color: "rgba(115, 140, 144, 1)",
    marginLeft: "1em",
  },
  selectBoxRTL: {
    marginLeft: "-.07em",
    marginRight: "unset",
  },
  rtltype: {
    marginRight: "1em",
  },
  customTooltip: {
    backgroundColor: "rgba(17, 94, 103, 1)",
  },
}));

type Props = {
  isActive?: boolean;
  item: ICardElementWithChildren;
  onSelect?: (item: ICardElementWithChildren) => void;
};

const ConfigReportCard = (props: React.PropsWithChildren<Props>) => {
  const { isActive, item } = props;
  const style = useStyles();
  return (
    <div
      className={style.root}
      onClick={() => {
        if (props.onSelect) {
          props.onSelect(item);
        }
      }}
    >
      <div className={clsx(style.upperContent, isActive && "active")}>
        {props.children}
        <div className={style.title}>{item.name}</div>
      </div>
      <div className={style.bottomContent}>
        <BlueChip>
          <ElementIcon item={item} size={16} />
          {item.typename}
        </BlueChip>
      </div>
    </div>
  );
};

export default ConfigReportCard;
